import PropTypes from 'prop-types'
import Modal from '@/components/Modal'
import CardConfigure from '@/components/Modal/CardConfigure'
import Button from '@/components/Button'
import InformationCircle from '@/assets/svgs/information-circle.svg?react'

export const ApproveModal = ({ visible, onClose, onConfirm }) => (
  <Modal visible={visible} close={onClose} variant="small" dataTestId="submittal-approve-modal">
    <CardConfigure>
      <CardConfigure.Header>
        <CardConfigure.Header.Title>
          <div className="flex items-center w-full">
            <div className="flex items-center">
              <div className="bg-theme-95 text-theme-50 [&_svg]:w-6.5 [&_svg]:h-6.5">
                <InformationCircle />
              </div>
              <div className="ml-4">
                <div className="font-avenir-heavy type-header-4 text-grey-30">Approve Request</div>
              </div>
            </div>
          </div>
        </CardConfigure.Header.Title>
      </CardConfigure.Header>
      <CardConfigure.Body>
        <CardConfigure.Body.Col>
          <p className="font-avenir-medium type-body-2 text-grey-40 mb-0 text-center">
            This action will share data element to the designated recipient. Please confirm all
            details are correct before proceeding.
          </p>
        </CardConfigure.Body.Col>
      </CardConfigure.Body>
      <CardConfigure.Footer>
        <CardConfigure.Footer.Left>
          <Button data-testid="submittal-approve-cancel-btn" round noborder onClick={onClose}>
            Cancel
          </Button>
        </CardConfigure.Footer.Left>
        <CardConfigure.Footer.Right>
          <Button data-testid="submittal-approve-confirm-btn" round onClick={onConfirm}>
            Confirm
          </Button>
        </CardConfigure.Footer.Right>
      </CardConfigure.Footer>
    </CardConfigure>
  </Modal>
)

ApproveModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
}
